module.exports = __webpack_public_path__ + "static/media/Entrepreneurship Management.1a887209.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OTH/Entrepreneurship Management.pdf
// module id = 150
// module chunks = 0